/**
 * DEV-1686: окно 24 часов WhatsApp Business и шаблоны Meta.
 * Вне окна свободный текст WhatsApp не принимает — остаются только одобренные
 * шаблоны, а снова открыть окно может лишь входящее сообщение клиента.
 */
export const messengerTemplatesMessages = {
  ru: {
    messenger: {
      waWindow: {
        bannerTitle: 'Окно 24 часа закрыто',
        bannerText:
          'Клиент не писал больше суток — свободные сообщения недоступны (правило WhatsApp Business). Отправьте утверждённый шаблон: ответ клиента снова откроет окно.',
        footerHint: 'Ввод недоступен до ответа клиента',
        templateButton: 'Шаблон',
      },
      waTemplates: {
        title: 'Отправить шаблон',
        hint: 'Вне окна 24 часа WhatsApp принимает только шаблоны, одобренные Meta.',
        empty: 'Нет одобренных шаблонов',
        retry: 'Обновить',
        paramsTitle: 'Параметры',
        param: 'Параметр {index}',
        preview: 'Предпросмотр',
        submit: 'Отправить',
      },
    },
  },
  en: {
    messenger: {
      waWindow: {
        bannerTitle: '24-hour window closed',
        bannerText:
          'The client has not written for over a day — free-form messages are unavailable (WhatsApp Business rule). Send an approved template: the client’s reply reopens the window.',
        footerHint: 'Input is locked until the client replies',
        templateButton: 'Template',
      },
      waTemplates: {
        title: 'Send a template',
        hint: 'Outside the 24-hour window WhatsApp only accepts templates approved by Meta.',
        empty: 'No approved templates',
        retry: 'Refresh',
        paramsTitle: 'Parameters',
        param: 'Parameter {index}',
        preview: 'Preview',
        submit: 'Send',
      },
    },
  },
  vn: {
    messenger: {
      waWindow: {
        bannerTitle: 'Cửa sổ 24 giờ đã đóng',
        bannerText:
          'Khách hàng đã không nhắn tin hơn một ngày — không thể gửi tin nhắn tự do (quy định của WhatsApp Business). Hãy gửi mẫu đã được duyệt: khi khách trả lời, cửa sổ sẽ mở lại.',
        footerHint: 'Không thể nhập cho đến khi khách trả lời',
        templateButton: 'Mẫu',
      },
      waTemplates: {
        title: 'Gửi mẫu tin nhắn',
        hint: 'Ngoài cửa sổ 24 giờ, WhatsApp chỉ chấp nhận các mẫu đã được Meta duyệt.',
        empty: 'Chưa có mẫu nào được duyệt',
        retry: 'Tải lại',
        paramsTitle: 'Tham số',
        param: 'Tham số {index}',
        preview: 'Xem trước',
        submit: 'Gửi',
      },
    },
  },
}
